<template>
  <div v-if="isLoading || !isEdit || !empty(product)">
    <a-card class="style1 category w-100" :class="[isDesktop ? 'desktop' : 'mobile']">
      <a-form :form="form" :label-col="isDesktop ? { span: 4 } : {}" :wrapper-col="isDesktop ? { span: 20 } : {}" :layout="isDesktop ? 'horizontal' : 'vertical'" @submit="handleSubmit">
        <a-form-item label="Name">
          <a-input
            v-decorator="[
              'name',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input name!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="SKU">
          <a-input
            v-decorator="[
              'sku',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input sku!',
                  },
                ],
              },
            ]"
            style="max-width: 240px;"
          />
        </a-form-item>
        <a-form-item label="Price">
          <a-input-number
            v-decorator="[
              'price',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input price!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Category">
          <a-select
            v-decorator="[
              'product_category_id',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please select category!',
                  },
                ],
              },
            ]"
            style="width: 320px;"
          >
            <a-select-option v-for="cat in categories" :key="cat.id">
              {{ cat.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Description">
          <wysiwyg
            v-model="description"
            v-decorator="[
              'description',
              {
                rules: [
                  {
                    required: true,
                    validator: (rule, value, callback) => validateInput(rule, value, callback, 'Please input description!'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Thumbnail">
          <a-upload
            v-decorator="['thumbnail']"
            action
            list-type="picture-card"
            :file-list="thumbnail"
            :before-upload="beforeUpload"
            @preview="openPreview"
            @change="({ fileList }) => (thumbnail = fileList)"
            class="thumbnail"
          >
            <div v-if="thumbnail.length === 0">
              <a-icon type="plus" />
              <div class="ant-upload-text">Upload</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="Images" v-if="false">
          <a-upload action list-type="picture-card" :file-list="images" :before-upload="beforeUpload" @preview="openPreview" @change="({ fileList }) => (images = fileList)">
            <div v-if="images.length < 4">
              <a-icon type="plus" />
              <div class="ant-upload-text">Upload</div>
            </div>
          </a-upload>
          <a-modal :visible="previewVisible">
            <template slot="footer">
              <a-button key="back" @click="previewVisible = false"> Close </a-button>
            </template>
            <img alt="example" style="width: 100%;" :src="previewImage" />
          </a-modal>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 20, offset: 4 }">
          <a-tag color="red" class="d-block p-1" v-if="!empty(error)">{{ error }}</a-tag>
          <a-button type="primary" html-type="submit" :loading="isLoading">{{ isEdit ? 'Update Product' : 'Create Product' }}</a-button>
        </a-form-item>
      </a-form>
      <a-modal :visible="previewVisible">
        <template slot="footer">
          <a-button key="back" @click="previewVisible = false"> Close </a-button>
        </template>
        <img alt="example" style="width: 100%;" :src="previewImage" />
      </a-modal>
    </a-card>
    <Loading :isLoading="isLoading" :type="typeLoading" :percent="percentLoading" />
  </div>
  <div v-else>
    <h2>Product not found</h2>
    <a-button type="primary" class="mb-3" @click="$router.push({ name: 'AdminProducts' })">Go to Product List</a-button>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Uploader from '@/services/UploadService';
import AdminService from '@/services/AdminService';
import Loading from '@/views/profile/loading';
import { empty, getBase64 } from '@/utils';
import { get } from 'lodash';
export default {
  components: {
    Loading,
  },
  data() {
    return {
      error: '',
      product: {},
      isLoading: false,
      previewVisible: false,
      categories: [],
      description: '',
      previewImage: '',
      thumbnail: [],
      images: [],
      typeLoading: 'submit',
      percentLoading: 0,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: 'product_category_form',
    });
  },
  computed: {
    ...mapState(['settings']),
    isEdit() {
      return this.$route.params.id !== 'create';
    },
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  watch: {
    $route: {
      handler(route) {
        if (this.isEdit) {
          this.doGetProductInfo(route.params.id);
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    this.$title = this.$route.meta.title;
    await this.doInitData();
  },
  methods: {
    empty,
    async doGetProductInfo(id) {
      try {
        this.isLoading = true;
        this.product = await AdminService.store.getProduct(id);
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },
    async doInitData() {
      this.categories = await AdminService.store.getCategories();

      if (this.isEdit) {
        this.thumbnail = [];
        // eslint-disable-next-line camelcase
        const { thumbnail, images } = this.product;

        if (!empty(thumbnail)) {
          this.thumbnail.push({
            uid: '-1',
            status: 'done',
            name: this.getFileName(thumbnail),
            url: thumbnail,
          });
        }

        if (!empty(images)) {
          this.images = images.map(img => ({
            uid: '-1',
            status: 'done',
            name: this.getFileName(img),
            url: img,
          }));
        }

        this.isLoading = false;
        this.$nextTick(() => {
          const { name, sku, price, product_category_id, description } = this.product;
          this.form.setFieldsValue({ name, sku, price, product_category_id, description });
          this.description = description;
        });
      }
    },
    defaultSize() {
      return {
        width: 10000,
        height: 10000,
        minHeight: 250,
        minWidth: 190,
      };
    },
    validateInput(rule, value, callback, message) {
      if (empty(value) || value === '<br>') {
        return callback(message);
      }
      callback();
    },
    getFileName(path) {
      let fileName = '';
      // eslint-disable-next-line no-useless-escape
      const patt = /\/([^\\\/:*\"<>|]+)$/g;
      const n = patt.exec(path);
      if (n !== null) {
        fileName = n[1];
      }
      return fileName;
    },
    handleUploadProgressing(percent, location) {
      this.percentLoading = percent;
      this.typeLoading = location;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            this.error = '';
            // upload image
            const dataSubmit = {};

            if (this.thumbnail.length) {
              if (this.thumbnail[0].status === 'done') {
                dataSubmit['thumbnail'] = this.thumbnail[0].url;
              } else {
                this.handleUploadProgressing(0, 'Thumbnail');
                const thumbnailContent = this.thumbnail[0];
                let thumbnail = {
                  contentType: thumbnailContent.type, // you can set it based on the type of image you are uploading like image/png
                  fileName: thumbnailContent.name,
                  file: thumbnailContent.preview || (await getBase64(thumbnailContent.originFileObj)),
                };
                const respthumbnail = await new Uploader().uploadImage(thumbnail, percent => this.handleUploadProgressing(percent, 'Thumbnail'));
                dataSubmit['thumbnail'] = respthumbnail.Location;
              }
            } else if (!empty(values['thumbnail'])) {
              dataSubmit['thumbnail'] = values['thumbnail'].url;
            }

            // if (this.images.length) {
            // }

            ['name', 'sku', 'price', 'product_category_id', 'description'].forEach(item => {
              if (!empty(values[item])) {
                dataSubmit[item] = values[item];
              }
            });

            this.typeLoading = 'submit';
            if (!this.isEdit) {
              await AdminService.store.createProduct(dataSubmit);
              this.$notification['success']({
                message: 'Create successful.',
                description: `${dataSubmit.name} was created successfully.`,
              });
            } else {
              await AdminService.store.updateProduct(this.product.id, dataSubmit);
              this.$emit('onSuccess');
              this.$notification['success']({
                message: 'Update successful.',
                description: `${dataSubmit.name} was updated successfully.`,
              });
            }
            this.$router.push({ name: 'AdminProducts' });
          } catch (error) {
            console.log(error);
            this.error = get(error, 'response.data.error', error.message);
          } finally {
            this.isLoading = false;
          }
        } else {
          window.parent.scrollTo(0, 0);
        }
      });
    },
    openPreview(file) {
      this.previewImage = null;
      this.$nextTick(async () => {
        if (file.url) {
          this.previewImage = file.url;
        } else {
          file.preview = file.preview || (await getBase64(file.originFileObj));
          this.previewImage = file.preview;
        }
        this.previewVisible = true;
      });
    },
    beforeUpload(file) {
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
<style lang="scss">
.category {
  &.mobile {
    .editr--toolbar {
      height: 100%;
      flex-wrap: wrap;
      .vw-btn-separator {
        display: none;
      }
    }
    .ant-card-body {
      .ant-upload-list-item-actions {
        left: 25px;
        top: calc(100% + 20px);
        opacity: 1;
        i {
          color: rgba(#000, 0.8);
          opacity: 1;
          font-size: 20px;
        }
        > a {
          margin-right: 10px;
        }
      }
    }
  }
  .ant-card-body {
    .embedIcon {
      .ant-upload-list-picture-card .ant-upload-list-item,
      .ant-upload-list-picture-card-container,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
        width: 100%;
        height: 100%;
        max-width: 937px;
        max-height: 341px;
      }
    }
    .background {
      .ant-upload-list-picture-card .ant-upload-list-item,
      .ant-upload-list-picture-card-container,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
        width: 100%;
        height: 100%;
        max-width: 190px;
        max-height: 250px;
      }
    }
    .ant-upload-list-item-actions {
      i {
        font-size: 26px;
        width: auto;
      }
    }
  }
}
.ant-modal-root.edit-product .ant-modal-body {
  .ant-spin-spinning {
    display: block;
    margin: auto;
  }
}
.select-from-gallery {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  > span {
    width: initial;
  }
}
</style>
